import * as React from 'react';
import { useSelector } from 'react-redux';
import { ModalWindow } from '@cian/ui-kit/modal';
import { OtpForm } from '../../components/OtpForm';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { selectOtpModalIsOpen } from '../../selectors/otpModal';
import { changeOtp, confirmOtp } from '../../actions/otp';
import { confirmPhone } from '../../actions/phone';
import { closeOtpModal } from '../../actions/otpModal';
import { selectOtp, selectFetchOtpError } from '../../selectors/otp';

export const ModalContainer = () => {
  const open = useSelector(selectOtpModalIsOpen);
  const otp = useSelector(selectOtp);
  const error = useSelector(selectFetchOtpError);

  const dispatch = useAppDispatch();

  const changeOptValue = (digit: string) => {
    dispatch(changeOtp(digit));
  };

  const sendOtp = (code: string) => {
    dispatch(confirmOtp(code));
  };

  const resendOtp = () => {
    dispatch(confirmPhone());
  };

  return (
    <ModalWindow
      open={open}
      escape
      fixed={false}
      width={448}
      onClose={() => dispatch(closeOtpModal())}
      content={<OtpForm otp={otp} error={error} setOtp={changeOptValue} sendOtp={sendOtp} resendOtp={resendOtp} />}
      outside
      size="XS"
      title="Введите код из СМС"
    />
  );
};
